import TenantBar from "./TenantBar.jsx";
import MenuButton from "./MenuButton.jsx";
import UserBar from "./UserBar.jsx";
import LogoEchoSystem from "../ui/LogoEchoSystem.jsx";
import useTenant from "../../hooks/useTenant.js";

const HeaderNavBar = ({
  openMenu,
  setOpenMenu,
  companiesList,
  branchesList,
  tenantUsername,
  tenantImage,
  tenant,
  companySelected,
  branchSelected,
}) => {
  return (
    <>
      <div className="w-[100%] flex justify-between items-center bg-[#251658] sticky top-0 z-50 text-white">
        <div className="px-2 py-0.5 m-auto w-full flex justify-between items-center">
          <div className="flex flex-col md:flex-row w-full justify-between items-center">
            <div className="flex items-center justify-between w-full ">
              {/* <MenuButton openMenu = {openMenu}  setOpenMenu = {setOpenMenu} /> */}
              <TenantBar
                companiesList={companiesList}
                branchesList={branchesList}
                companySelected={companySelected}
                branchSelected={branchSelected}
              />
            </div>
            <LogoEchoSystem name="مستودعات" tenantUsername={tenantUsername} />
            <UserBar
              tenantUsername={tenantUsername}
              tenantImage={tenantImage}
              tenant={tenant}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderNavBar;
